import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/index';
import { GroupType, UserType } from '../enums/enums';
import { ServicesService } from '../services/services.service';
import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private services: ServicesService,
    private sessionService: SessionService,
    private _router: Router,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    let user = this.sessionService.getUser();
    let currentRole = this.services.roleService.getCurrentRole();
    if (this.sessionService.isLoggedIn() && currentRole) {
      if (this.sessionService.hasRole(GroupType.Hcp)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Hcp);
      } else if (this.sessionService.hasRole(GroupType.Benefit)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Benefit);
      } else if (this.sessionService.hasRole(GroupType.Companie)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Companie);
      } else if (this.sessionService.hasRole(GroupType.Admin)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Admin);
      } else if (
        this.sessionService.hasRole(GroupType.Kimbo) ||
        user.user_type === UserType.Guest
      ) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Kimbo);
      } else {
        this._router.navigate(['/404']);
      }
      return false;
    } else {
      this.sessionService.loginGuest();
      return true;
    }
  }
}

export class LoginGuard_ implements CanActivate {
  constructor(
    private services: ServicesService,
    private sessionService: SessionService,
    private _router: Router,
  ) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    let user = this.sessionService.getUser();
    let currentRole = this.services.roleService.getCurrentRole();
    if (this.sessionService.isLoggedIn() && currentRole) {
      if (this.sessionService.hasRole(GroupType.Hcp)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Hcp);
      } else if (this.sessionService.hasRole(GroupType.Benefit)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Benefit);
      } else if (this.sessionService.hasRole(GroupType.Companie)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Companie);
      } else if (this.sessionService.hasRole(GroupType.Admin)) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Admin);
      } else if (
        this.sessionService.hasRole(GroupType.Kimbo) ||
        user.user_type === UserType.Guest
      ) {
        this.services.roleService.changeRoleWithGroupType(GroupType.Kimbo);
      } else {
        this._router.navigate(['/404']);
      }
      return false;
    } else {
      return true;
    }
  }
}
